module.exports = __webpack_public_path__ + "static/media/qatar.0f1c6ae2.png";